// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-field-container {
    margin-bottom: 20px;
    width: 100%;
}

.table-title {
    font-size: 14px;
    font-weight: 500;
    color: var(--therapist-text-color);
    margin-bottom: 8px;
    align-self: flex-start;
}

.table-field {
    width: 100%;
    border-collapse: collapse;
}

.table-field th, .table-field td {
    border: 1px solid var(--therapist-border-color) !important;
    padding: 8px;
    text-align: center;
}

.table-field th {
    background-color: #f2f2f2;
}

.table-input {
    width: 100%;
    border: none;
    padding: 6px;
    text-align: center;
    outline: none;
}

.table-field td:last-child {
    border: none !important;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./app/components/therapist/medical-history/styles/TableField.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,0DAA0D;IAC1D,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".table-field-container {\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.table-title {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--therapist-text-color);\n    margin-bottom: 8px;\n    align-self: flex-start;\n}\n\n.table-field {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table-field th, .table-field td {\n    border: 1px solid var(--therapist-border-color) !important;\n    padding: 8px;\n    text-align: center;\n}\n\n.table-field th {\n    background-color: #f2f2f2;\n}\n\n.table-input {\n    width: 100%;\n    border: none;\n    padding: 6px;\n    text-align: center;\n    outline: none;\n}\n\n.table-field td:last-child {\n    border: none !important;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
